import React from "react";
import { Outlet } from "react-router-dom";

import Footer from "./Footer";
import Head from "./Head";

export default function LayoutLogin() {
  return (
    <main className="relative flex flex-grow flex-col bg-[#131313] text-white">
      <div className="flex flex-grow flex-col">
        <Outlet />
      </div>
    </main>
  );
}
